import AjaxClass from '@/ajax'

export default class PracticeQuestionService {
  ajax

  constructor (store) {
    this.ajax = new AjaxClass(store)
  }

  getList (then, params) {
    return this.ajax.get('/practice_questions', params, (data) => {
      sessionStorage.removeItem('hiddenLoading')
      return then(data)
    }, {hiddenLoading: !!sessionStorage.getItem('hiddenLoading')})
  }

  getItem (id, then, params) {
    return this.ajax.get('/practice_questions/' + id, params, (data) => {
      return then(data)
    })
  }

  saveItem (item, update, then) {
    return this.ajax.post('/practice_questions/save', {item: item, update: update}, (data) => {
      then(data)
    })
  }

  deleteItem (id, then) {
    return this.ajax.post('/practice_questions/delete', {id: id}, (data) => {
      then(data)
    })
  }

  static getDefaultItem () {
    return {
      id: '',
      number: '',
      category: '',
      text: '',
      answers: [{id: 0, text: '', cost: 20}, {id: 1, text: '', cost: 10}, {id: 2, text: '', cost: 0}]
    }
  }

  static getCosts () {
    return [20, 10, 0]
  }
}



// WEBPACK FOOTER //
// ./src/services/PracticeQuestionService.js